const API_BASE = 'https://api.insightos.co.uk';

/**
 * Initiates Google Calendar OAuth connection.
 * Calls POST /api/google/initiate first (with cookies) to get a pre-issued state token,
 * then navigates the browser to /api/googlesync?state=TOKEN → Google consent screen.
 * Falls back to cookie-based auth if the initiate endpoint is unavailable.
 */
export async function connectGoogleCalendar() {
  try {
    const res = await fetch(`${API_BASE}/api/google/initiate`, {
      method: 'POST',
      credentials: 'include',
    });

    if (res.ok) {
      const data = await res.json();
      // Preferred path: server returns the full Google OAuth URL, navigate directly.
      // This skips the /api/googlesync hop which can be dropped by reverse proxies.
      if (data.success && data.url) {
        window.location.href = data.url;
        return;
      }
      // Legacy fallback: server returned only a state token
      if (data.success && data.state) {
        window.location.href = `${API_BASE}/api/googlesync?state=${encodeURIComponent(data.state)}`;
        return;
      }
    }
    // Last resort: navigate directly — the server will use the auth cookie to identify the user
    console.warn('Google initiate unavailable or returned no state; falling back to direct redirect');
    window.location.href = `${API_BASE}/api/googlesync`;
  } catch (err) {
    console.error('❌ Google initiate error, falling back:', err);
    window.location.href = `${API_BASE}/api/googlesync`;
  }
}
